/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IssueStateData
 */
export interface IssueStateData {
    /**
     * 
     * @type {string}
     * @memberof IssueStateData
     */
    readonly state: string;
    /**
     * 
     * @type {string}
     * @memberof IssueStateData
     */
    readonly text: string;
    /**
     * 
     * @type {string}
     * @memberof IssueStateData
     */
    readonly color?: string;
}

/**
 * Check if a given object implements the IssueStateData interface.
 */
export function instanceOfIssueStateData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function IssueStateDataFromJSON(json: any): IssueStateData {
    return IssueStateDataFromJSONTyped(json, false);
}

export function IssueStateDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): IssueStateData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'state': json['state'],
        'text': json['text'],
        'color': !exists(json, 'color') ? undefined : json['color'],
    };
}

export function IssueStateDataToJSON(value?: IssueStateData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

